<button
  @click="logout"
  class="btn btn-default btn-flat float-right"
  >
  Sair
</button>